exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".SongsListingStylePicker-button {\n  appearance: none;\n  margin: 0;\n  padding: 8px;\n  background: none;\n  border: none;\n  outline: none;\n  color: #9ea0a3;\n  cursor: pointer; }\n  .SongsListingStylePicker-button:hover {\n    color: #0b1c31; }\n  .SongsListingStylePicker-button.isSelected {\n    color: #0068e9; }\n", ""]);

// exports
